import { SxProps } from '@mui/material';
import { black1, grey9 } from 'app/components/ThemeProvider/colors';

export const pageHeaderBox: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  mb: '32px',
};

export const titleBox: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
};

export const btnBox: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  height: '40px',
  gap: '12px',
};

export const btn: SxProps = {
  display: 'flex',
  gap: '8px',
  '& .MuiSvgIcon-root': { width: '22px', height: '22px' },
};

export const showBtn: SxProps = {};

export const greenBtn: SxProps = {
  backgroundColor: 'rgba(36, 176, 126, 0.95)',
  color: 'white',
  gap: '12px',
  paddingTop: '12px',
  paddingBottom: '12px',
  '&:hover': {
    background: '#1BAC78',
  },
};

export const menuItems: SxProps = {
  color: black1,
  display: 'flex',
  gap: '12px',
  fontSize: '15px',
  fontFamily: 'Yelo',
  p: '12px 16px',

  '&:hover': {
    color: `${black1} !important`,
    background: `${grey9} !important`,
  },
};
